import './supervisor-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { UserTrackingFunction } from '@tracking/models/tracking-function';
import { RESET_TRACKING_FILTER } from '@tracking/table/tracking-table.component.ajs';
import { IUserTrackingService } from '@tracking/tracking.service';
import { IComponentController, IComponentOptions } from 'angular';

import { MessagingService } from '@contact/upgrade';

import templateUrl from './supervisor-filter.component.ajs.html';

const MODULE_NAME = 'contactSupervisorFilter';

class SupervisorFilterControler implements IComponentController {
  public name = MODULE_NAME;

  private agentList: Array<any> = [];
  private selectedAgent: any = null;
  private campaignList: any[] = [];
  private selectedCampaign: any = null;
  private skillList: Array<any> = [];
  private selectedSkill: any = null;
  private onlyAlert: boolean;

  constructor(private readonly tracking: IUserTrackingService, private readonly messaging: MessagingService) {}

  $onInit() {
    this.tracking.setFunction(UserTrackingFunction.SUPERVISOR);

    this.tracking.getAgentList().then(agents => {
      this.agentList = agents.map(agent => {
        agent.name = `${agent.firstName}' '${agent.lastName}`;
        return agent;
      });
    });
    this.tracking.getCampaignList().then(campaigns => {
      this.campaignList = campaigns;
    });
    this.tracking.getSkillList().then(skills => {
      this.skillList = skills;
    });

    // RESET_TRACKING_FILTER
    this.messaging
      .forLocal()
      .listen$(RESET_TRACKING_FILTER)
      .pipe(ng1Destroy(this))
      .subscribe(() => this.resetFilters());
  }

  private updateFilters() {
    const idFilters: any[] = [];
    if (this.selectedAgent != null && this.selectedAgent.hasOwnProperty('uuid')) {
      idFilters.push(this.selectedAgent.uuid);
    }
    if (this.selectedSkill != null && this.selectedSkill.hasOwnProperty('uuid')) {
      idFilters.push(this.selectedSkill.uuid);
    }
    if (this.selectedCampaign != null && this.selectedCampaign.hasOwnProperty('idCampaign')) {
      idFilters.push(this.selectedCampaign.idCampaign);
    }
    if (idFilters.length > 0) {
      this.tracking.updateFilters('targetId', idFilters);
    } else {
      this.tracking.updateFilters('targetId', null);
    }
    if (this.onlyAlert) {
      idFilters.push('ALERT_TEMPLATE');
      this.tracking.updateFilters('targetType', idFilters);
    } else {
      this.tracking.updateFilters('targetType', null);
    }
  }

  public resetSkill(): void {
    this.selectedSkill = null;
    this.updateFilters();
  }

  private resetFilters(): void {
    this.selectedAgent = undefined;
    this.selectedCampaign = undefined;
    this.selectedSkill = undefined;
    this.onlyAlert = false;
  }

  get skills(): Array<any> {
    return this.skillList;
  }

  public skillChanged(): void {
    this.updateFilters();
  }

  public agentChanged() {
    this.updateFilters();
  }

  public alertChanged(): void {
    this.updateFilters();
  }

  get agents(): Array<any> {
    return this.agentList;
  }

  public campaignChanged() {
    this.updateFilters();
  }

  get campaigns(): Array<any> {
    return this.campaignList;
  }
}

export class SupervisorFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = ['tracking', 'messaging', SupervisorFilterControler];
}

export default MODULE_NAME;
